import { LOG_OUT, AUTH_CHECK } from '../../redux/reducers/auth/types'
import { GLOBALS } from '../../config'
import { get, post } from '../fetch'

export const authCheck = () => dispatch => {
  const callbackURL = GLOBALS.URL + window.location.pathname
  return dispatch(
    get(
      AUTH_CHECK.REQUEST,
      `auth/adminCheck`,
      null,
      error => {
         window.location.replace(`${GLOBALS.ACCOUNT_REDIRECT_URL}?redirect=${callbackURL}`)
      }
    )
  )
}

export const logOut = () => dispatch => {
  dispatch(
    post(
      LOG_OUT,
      `auth/logout`,
      {},
      () => window.location.replace(`${GLOBALS.ACCOUNT_REDIRECT_URL}?redirect=${GLOBALS.URL}`),
      () => window.location.reload()
    )
  )
}